export default {
  text: {
    en: 'And many more luxury brands to choose from.',
  },
}
